<!--
Author: TangChen
Date: 2018-09-10
Desc: 登录页面，实现手机，证件号登录，由router.js 配置引入
 -->
<template>
    <div class="view-login view">
        <header-com :tit="'用户登录'" />
        <div class="login-main">
            <div class="container">
                <div class="login-panel" :style="{ top: login_top + 'px' }">
                    <el-tabs v-model="loginUser">
                        <!-- <el-tab-pane label="经办人登录" name="b">
                            <div class="login-form">
                                <el-form ref="loginForm" :rules="rules" :model="loginForm" label-width="0" v-on:keyup.enter.native="login">
                                    <el-form-item label="" prop="certType" class="icon-select">
                                        <i class="fa fa-id-card select-card" />
                                        <el-select v-model="loginForm.certType" placeholder="请选择证件类型" v-on:change="checkCertNoAgain">
                                            <el-option v-for="item in perTypes" :key="item.subitem" :label="item.subitemname" :value="item.subitem" />
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="" prop="certNo">
                                        <el-input v-model="loginForm.certNo" :maxlength="18" placeholder="请输入证件号码" prefix-icon="fa fa-id-card" v-on:keyup.native="loginForm.certNo = checkinput(loginForm.certNo)" />
                                    </el-form-item>
                                    <el-form-item label="" prop="password">
                                        <el-input
                                            v-model="loginForm.password"
                                            type="password"
                                            class="reset-pwd"
                                            :maxlength="32"
                                            placeholder="请输入密码"
                                            prefix-icon="fa fa-lock"
                                            v-on:keydown.native="detectCapsLock"
                                        >
                                        </el-input>
                                        <div class="capsLock-tip js-capsLock" :class="{ hide: !capsLock }">
                                            <i class="capsLockTip-triangle" />
                                            大写锁定已打开
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="" prop="verifyCode">
                                        <el-input v-model="loginForm.verifyCode" placeholder="请输入验证码" :maxlength="4" prefix-icon="fa fa-shield">
                                            <span slot="append" class="prop-verify"><img :src="imgSrc" v-on:click="refresh"></span>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item class="login-btn">
                                        <el-button type="primary" class="login-n" v-on:click="login">
                                            立即登录
                                        </el-button>
                                        <el-button class="quick" v-on:click="register">
                                            快速注册
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-tab-pane> -->
                        <!--机构登录-->
                        <!-- <el-tab-pane label="证件登录" name="a"> -->
                        <div class="login-cert-type">
                            <el-radio-group v-model="loginCertType" v-on:change="resetForm">
                                <el-radio v-for="item in loginType" :key="item.id" :label="item.id">
                                    {{ item.name }}
                                </el-radio>
                            </el-radio-group>
                        </div>
                        <div class="login-form">
                            <el-form ref="orgForm" :rules="rules" :model="loginForm" label-width="0" v-on:keyup.enter.native="login">
                                <el-form-item v-if="loginCertType === '0'" label="" prop="certType" class="icon-select">
                                    <i class="fa fa-id-card select-card" />
                                    <el-select v-model="loginForm.certType" placeholder="请选择证件类型" v-on:change="checkCertNoAgain">
                                        <el-option v-for="item in certTypes" :key="item.subitem" :label="item.subitemname" :value="item.subitem" v-show="item.subitem==='00'"/>
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-else label="" prop="certType" class="icon-select">
                                    <i class="fa fa-id-card select-card" />
                                    <el-select v-model="loginForm.certType" placeholder="请选择证件类型" v-on:change="checkCertNoAgain">
                                        <el-option v-for="item in proTypes" :key="item.subitem" :label="item.subitemname" :value="item.subitem" v-show="item.subitem==='00'" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-if="loginForm.certType!='00'" label="" prop="custname">
                                    <el-input v-model="loginForm.custname" :maxlength="32" :placeholder="'请输入'+(loginCertType==='0'?'机构名称':'产品名称')" prefix-icon="fa fa-user" v-on:keyup.native="loginForm.custname = checkinput(loginForm.custname)" />
                                </el-form-item>
                                <el-form-item label="" prop="certNo">
                                    <el-input
                                        v-if="loginForm.certType!='00'"
                                        v-model="loginForm.certNo"
                                        :maxlength="32"
                                        placeholder="请输入证件号码"
                                        prefix-icon="fa fa-id-card"
                                        v-on:keyup.native="loginForm.certNo = checkinput(loginForm.certNo)"
                                    />
                                    <el-input
                                        v-else
                                        v-model="loginForm.certNo"
                                        :maxlength="12"
                                        placeholder="请输入基金账号"
                                        prefix-icon="fa fa-id-card"
                                        v-on:keyup.native="loginForm.certNo = checkinput(loginForm.certNo)"
                                    />
                                </el-form-item>
                                <el-form-item label="" prop="password">
                                    <el-input
                                        v-model="loginForm.password"
                                        type="password"
                                        class="reset-pwd"
                                        :maxlength="32"
                                        placeholder="请输入密码"
                                        prefix-icon="fa fa-lock"
                                        v-on:keydown.native="detectCapsLock"
                                    >
                                    </el-input>
                                    <div class="capsLock-tip js-capsLock" :class="{ hide: !capsLock }">
                                        <i class="capsLockTip-triangle" />
                                        大写锁定已打开
                                    </div>
                                </el-form-item>
                                <el-form-item label="" prop="verifyCode">
                                    <el-input v-model="loginForm.verifyCode" placeholder="请输入验证码" :maxlength="4" prefix-icon="fa fa-shield">
                                        <span slot="append" class="prop-verify"><img :src="imgSrc" v-on:click="refresh"></span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item class="login-btn">
                                    <el-button type="primary" class="login-n" v-on:click="login">
                                        立即登录
                                    </el-button>
                                    <!-- 暂时禁用开户功能 -->
                                    <!-- <el-button class="quick" v-on:click="register">
                                        快速注册
                                    </el-button> -->
                                </el-form-item>
                            </el-form>
                        </div>
                        <!-- </el-tab-pane> -->
                    </el-tabs>
                </div>
            </div>
            <el-carousel id="carousel" :interval="5000" :height="ad_height + 'px'">
                <el-carousel-item v-for="item in ads" :key="item.imgid">
                    <div class="login-ad">
                        <a v-if="item.linkurl" :href="item.linkurl" :target="item.opentype === '2' ? '_blank' : '_self'">
                            <img :src="item.imgid" :style="{ height: ad_height + 'px', width: ad_width + 'px' }">
                        </a>

                        <img v-if="!item.linkurl" :src="item.imgid" :style="{ height: ad_height + 'px', width: ad_width + 'px' }">
                    </div>
                </el-carousel-item>
            </el-carousel>
            <log />
        </div>
        <footer-com />
        <user-check :visible="visible" :check-list="checkList" v-on:back-sel="backSel"></user-check>
    </div>
</template>
<script>
import headerCom from "@/components/common/header.vue";
import footerCom from "@/components/common/footer.vue";
import userCheck from "@/components/acctInfo/userCheck.vue";
import log from "@/components/common/log.vue";
export default {
    components: {
        headerCom,
        footerCom,
        userCheck,
        log
    },
    data() {
        return {
            imgRefresh: null,
            ad_ratio: 3, // 轮播广告图片的长宽比
            ad_width: 0,
            ad_height: 0, // 轮播广告图片高度，由setPageSize方法计算后赋值
            login_top: "10",
            ads: [],
            loginType: [{ id: "0", name: "机构客户" }, { id: "2", name: "产品客户" }],
            /* { id: "1", val: "QQ账号", url: "qq_icon" }, */
            certTypes: [], // 机构证件类型
            proTypes: [], // 产品证件类型
            // perTypes: [], // 证件类型
            loginForm: {
                phone: "",
                password: "",
                verifyCode: "",
                custname: "",
                certType: "00",
                certNo: ""
            },
            imgSrc: "",
            checkList: [],
            visible: false,
            loginUser: "a",
            loginCertType: "0",
            capsLock: false,
            rules: {
                certType: [{ required: true, message: "请选择证件类型", trigger: "change" }],
                custname: [{ required: true, message: "请输入对应名称", trigger: "change" }],
                certNo: [{ required: true, message: "请输入证件号码", trigger: "blur" }, { validator: this.checkCertNo, trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                verifyCode: [{ validator: this.$util.validateImgVerifyCode, trigger: "blur" }]
            },
            /* wx跳转 */
            wxLoginParam: {}
        };
    },
    watch: {
        loginUser(){
            this.resetForm();
        },
        "loginForm.certType"(){
            const _x = this.loginUser === "b" ? "loginForm" : "orgForm";
            this.loginForm.certNo = "";
            this.loginForm.custname = "";
            this.loginForm.password = "";
        }
    },
    created() {
        sessionStorage.setItem("alreadyread","");
        this.getImgInfo();
        this.refresh();
        this.$cache.initCityCountyList();
    },
    mounted() {
        document.body.onresize = (function(o) {
            return function() {
                o.setPageSize();
            };
        })(this);
        // this.perTypes = this.$cache.getDict("130007");
        this.certTypes = this.$cache.getDict("130008").concat([{
            dictitem: "130007",
            subitem: "00",
            subitemname: "基金账号",
            sysid: "4"
        }]);
        this.proTypes = this.$cache.getDict("120095").concat([{
            dictitem: "130007",
            subitem: "00",
            subitemname: "基金账号",
            sysid: "4"
        }]);
        this.setPageSize();
        // 前端心跳-每隔3分钟刷新验证码图片，以达到登录页面用不超时的效果
        this.imgRefresh = setInterval(
            (function(o) {
                return function() {
                    o.refresh();
                };
            })(this), 180000);

        this.isIE();
        this.checkEncWay();
    },
    beforeDestroy() {
        clearInterval(this.imgRefresh);
    },
    methods: {
        /* ie浏览器大写锁定提示框 */
        isIE() {
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                document.msCapsLockWarningOff = true;
            }
            else {
                return false;
            }
        },
        /* 查看柜台是否开启国密 2.2 */
        checkEncWay () {
            this.$util.getGtParamsValue ("1001164",res => {
                if(res.paramvalue.indexOf("A90") > -1) {
                    sessionStorage.setItem("isOpenGMEnc", "1");
                }else {
                    sessionStorage.setItem("isOpenGMEnc", "0");
                }
                if(res.paramvalue.indexOf("A88") > -1) {
                    sessionStorage.setItem("isTaTwo", true);
                }else {
                    sessionStorage.setItem("isTaTwo", false);
                }
            });
        },
        /* 去掉字符串前面的空格 */
        checkinput(s) {
            return s.replace(/(^\s*)/g, "");
        },
        /* 处理banner宽度和高度 */
        setPageSize() {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w = w < 1200 ? 1200 : w;
            this.ad_width = w;
            this.ad_height = w / this.ad_ratio;
            if (this.ad_height < 500) {
                this.ad_height = 500;
                this.ad_width = this.ad_height * this.ad_ratio;
            }
            // 登录表单位置计算
            this.login_top = (this.ad_height - 470) / 2;
        },
        /* 校验证件号码 */
        checkCertNo(rule, value, callback) {
            if (this.loginForm.certType == "00") {
                this.$util.validateChar(rule, value, callback);
            }else{
                this.$util.validateCertNo(rule, value, callback, this.loginForm.certType, this.loginUser === "b");
            }
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.loginForm.validateField("certNo");
            this.$refs.orgForm.validateField("certNo");
        },
        // 判断是否开启大写输入
        detectCapsLock() {
            this.capsLock = this.$util.detectCapsLock();
        },
        /* 刷新验证码图片 */
        refresh() {
            this.imgSrc = this.$util.imgUrl();
        },
        // 选中机构账户
        backSel(val){
            this.visible = false;
            if(val){
                this.formValidSuccess(val);
            }else{
                this.refresh();
            }
        },
        /* 表单重置 */
        resetForm() {
            const _x = this.loginUser === "b" ? "loginForm" : "orgForm";
            this.$refs[_x].resetFields();
            // 解决表单切换
            this.loginForm.certNo = "";
//            this.loginForm.certType = this.loginUser === "b" ? "0" : "1";
        },
        /* 表单登录 */
        login() {
            // const _x = this.loginUser === "b" ? "loginForm" : "orgForm";
            this.$refs["orgForm"].validate(valid => {
                if (valid) {
                    this.formValidSuccess();
                    return false;
                } else {
                    // todo
                    return false;
                }
            });
        },
        /* 快捷注册 */
        register() {
            this.$router.push({ name: "openinfo" });
        },
        getImgInfo() {
            const x = this.$cache.getAdvertiseInfo("1");
            for (let i in x) {
                x[i].imgid = this.$util.src("/common/download", { id: x[i].fileid });
            }
            this.ads = x;
        },
        // 开户未完成
        openVal(val,id){
            const _this = this;
            _this.$cache.setSession(val);
            _this.$util.request("orgopen/wateinfo",{ transid: id }).then(data=>{
                const _x = data.data[0] || {};
                const _d = {
                    certificatetype: _x.certificatetype,
                    organization: _x.organization,
                    invtp: _x.invtp,
                    taxregistrationcert: _x.taxregistrationcert
                };
                sessionStorage.setItem("refuse",JSON.stringify(_d));
                let _url = _x.openstep === "1" ? "orgtype" : (_x.openstep === "2" ? "orgregister" : "bankinfo");
                this.$confirm("您的账户还未开户成功，暂时不能登录，请继续填写资料完成开户。", "登录提示", {
                    confirmButtonText: "继续开户",
                    cancelButtonText: "暂未准备好",
                    type: "warning",
                    customClass: "info-check"
                }).then(() => {
                    _this.$store.dispatch("putTransid",id).then(() => {
                        _this.$router.push({name: _url});
                    });
                }).catch(()=>{
                    _this.refresh();
                });
            });

        },
        /* 登录成功 */
        formValidSuccess(custid) {
            const _this = this;
            const loginPwd = this.$util.enc(this.loginForm.password);
            let t = this.loginForm.certType;
            let a = this.loginUser;
            if( t == "00"){
                a = "2";
            }
            const _data = {
                accttype: a,
                certificatetype: t,
                certificateno: this.loginForm.certNo,
                mobile: this.loginForm.phone,
                investortype: this.loginCertType,
                verifycode: this.loginForm.verifyCode,
                loginpwd: loginPwd
            };
            if(custid){
                _data.custid = custid;
            }
            if(this.loginUser === "a"){
                _data.custname = this.loginForm.custname;
            }
            this.$req({ url: "/common/login", data: _data, method: "POST" }).then(res => {
                // 登录状态和数据更新
                if (res.code === "0000000") {
                    const x = res.record[0][0];
                    if(x.loginflag === "1"){
                        _this.$store.dispatch("login", x).then(() => {
                            _this.$router.replace("org/home");
                        });
                        // 开通交易账号
                        if(["2","3","4"].includes(_this.$cache.getUser().usertype)){
                            _this.openTrademethod();
                        }
                    }else if(x.loginflag === "2"){
                        _this.openVal(x,res.record[1][0].transid);
                    }else if(x.loginflag === "3"){
                        _this.visible = true;
                        _this.checkList = res.record[1];
                    }
                } else {
                    _this.refresh();
                    _this.$message({
                        type: "warning",
                        message: res.msg
                    });
                }
            }).catch(() => {
                _this.refresh();
            });
        },
        openTrademethod(){
            this.$util.request("acct/trademethod/open",{},"POST").then(res => {
                if (res.data) {

                }
            });
        },
    }
};
</script>
<style lang="scss">
.view-login {
	.login-main {
		background: #cbcbcb;
		.el-carousel {
			width: 100%;
			overflow: hidden;
			min-width: 1200px;
		}
		.container {
			position: relative;
			.login-panel {
				box-shadow: 0 0 5px #c3c3c3;
				.el-tabs__content {
					background-color: #f9f9f9;
				}
				width: 360px;
				position: absolute;
				right: 0;
				top: 100px;
				z-index: 999;
				padding: 10px 0 0;
				border-radius: 6px 6px;
				overflow: hidden;
				.el-tabs__header.is-top {
					margin: 0;
				}
				.el-tabs__nav-wrap.is-scrollable {
					padding: 0;
				}
				.el-tabs__active-bar {
					width: 180px !important;
					background: #e99400;
				}
				.el-tabs__item {
					width: 180px;
					padding: 0;
					font-size: 16px;
					text-align: center;
				}
				.login-cert-type {
					padding: 11px 0;
					.el-radio {
						display: inline-block;
						width: 156px;
						margin-right: 0;
						text-align: left;
						padding-left: 24px;
						.el-radio__label {
							line-height: 24px;
							font-size: 16px;
						}
					}
					.el-radio + .el-radio {
						margin: 0;
					}
				}
				.login-other {
					padding: 15px 10px 15px 13px;
					.login-other-box {
						display: inline-block;
						.other-list {
                            cursor: pointer;
							margin-right: 20px;
							display: inline-block;
							.other-list-img {
								vertical-align: middle;
								width: 23px;
								height: 23px;
								display: inline-block;
							}
							.other-list-text {
								margin-left: 5px;
                                vertical-align: middle;
							}
						}
					}
					.login-btn-msg {
						display: inline-block;
						vertical-align: middle;
						.d-login {
							float: right;
                            padding: 0;
                            span{line-height: 23px;display: inline-block;}
						}
					}
				}
				.login-form {
					padding: 10px 15px 0;
					.el-form-item {
						&.icon-select {
							position: relative;
						}
						&.login-btn {
							padding: 5px 0 21px 0;
                            display: flex;
                            justify-content: center; //登录按钮样式居中
							text-align: center;
							margin-bottom: 0;
							.login-n {
								float: left;
								font-size: 16px;
								min-width: 150px;
							}
							.quick {
								font-size: 16px;
								float: right;
								min-width: 150px;
							}
						}
						.fa.fa-id-card.select-card {
							position: absolute;
							z-index: 1000;
							font-size: 20px;
							color: #c0c4cc;
							top: 11px;
							left: 6px;
						}
						margin-bottom: 16px;
						.el-select {
							width: 330px;
							.el-input__inner {
								padding-left: 40px;
							}
						}
						.el-input {
							.el-input__inner {
								border: none;
								border-radius: 0;
								padding-left: 40px;
							}
							.el-input__icon {
								font-size: 20px;
								// color:
							}
						}
						.el-form-item__error {
							padding: 0;
							width: 100%;
							text-indent: 40px;
							//background: $bg6;
							font-size: 14px;
							padding: 4px 0;
							z-index: 2;
							font-family: 'element-icons' !important;
							font-style: normal;
							font-weight: normal;
							font-variant: normal;
							text-transform: none;
							line-height: 1;
							vertical-align: baseline;
							display: inline-block;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
						}
						.el-col.el-col-19 {
							.el-form-item--small.el-form-item {
								margin-bottom: 0px;
							}
						}
						.reset-pwd .el-input-group__append {
							width: 38px;
						}
						.el-input-group__append {
							border: none;
							background: none;
							padding: 0;
							cursor: pointer;
							.reset-btn {
								padding: 0;
							}
							.prop-verify {
								height: 38px;
								float: right;
							}
						}
					}
				}
			}
		}
	}
}
</style>
